<!-- @file 中奖名单组件 -->

<template>
  <div class="plv-lottery-list-default">
    <template v-if="isGroup">
      <div class="plv-lottery-list-default__group">
        <div
          v-for="(item, index) in groupList"
          :key="`group-${index}`"
          class="plv-lottery-list-default__group__item"
          :class="{
            'plv-lottery-list-default__group__item--active': item.id === currentGroupId
          }"
          @click="switchGroup(item)"
        >{{ item.title }}({{ item.count || 0 }})</div>
      </div>
    </template>
    <div class="plv-lottery-list-default__main">
      <ul
        v-if="winnerGroups.length"
        class="plv-lottery-list-default__main__list"
        @scroll="onScroll"
      >
        <li v-for="(group, index) in winnerGroups" :key="index">
          <span v-for="(user, userIndex) in group" :key="userIndex">
            {{ user.viewerName }}
          </span>
        </li>
      </ul>
      <div
        v-if="!isLoading && winnerGroups.length === 0"
        class="plv-lottery-list-default__main__list__empty"
      >{{ iarTrans('lottery.groupEmpty') }}</div>
    </div>
    <div>
      <div class="plv-lottery-list-default__footer">
        <iar-button @click="onClickBack">
          {{ iarTrans('lottery.back') }}
        </iar-button>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin';
import IarButton from '../../../components/common/button/MobileButton';

export default {
  components: {
    IarButton,
  },

  mixins: [mixin],
};
</script>

<style lang="scss">
.plv-lottery-list-default__group {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  background: #EDF1F7;
  height: 46px;
  flex-shrink: 0;
}
.plv-lottery-list-default__group__item {
  min-width: 100px;
  box-sizing: border-box;
  text-align: center;
  height: 46px;
  flex-shrink: 0;
  padding: 0 8px;
  line-height: 46px;
  color: #666666;
  font-size: 16px;
}
.plv-lottery-list-default__group__item--active {
  color: #2296F3;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 30px;
    height: 2px;
    background: #2296F3;
  }
}
.plv-lottery-list-default__main {
  height: 180px;
}
.plv-lottery-list-default__main__list__empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  color: #999;
}
.plv-lottery-list-default__main__list {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: auto;
  li {
    background: #ffffff;
    height: 48px;
    line-height: 48px;
    span {
      width: 33.3%;
      padding: 0 14px;
      box-sizing: border-box;
      display: inline-block;
      text-align: center;
      color: #546e7a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
    }
  }
  li:nth-child(2n) {
    background: #F8F8FB;
  }
}

.plv-lottery-list-default__footer {
  text-align: center;
  padding: 24px;
}
</style>
